import PropTypes from "prop-types";
import React from "react";
// import { StaticQuery, graphql } from "gatsby";

import { matchPath, withRouter } from "react-router";

// ^^ A Link element for our custom history router.

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faChevronDown as farChevronDown } from "@fortawesome/pro-regular-svg-icons";

import SEO from "../../../../global-components/seo";

import * as ROUTES from "../../constants/routes.js";

// import ImageShimmer from "./ImageShimmer";

import CCPA from "../../../Home/pages/Legal/CCPA";
import CookiesPolicy from "../../../Home/pages/Legal/CookiesPolicy";
import PrivacyPolicy from "../../../Home/pages/Legal/PrivacyPolicy";
import TermsOfService from "../../../Home/pages/Legal/TermsOfService";
import CareersPage from "../../pages/CareersPage";
import PopupPages from "./PopupPages";
import CloseButton from "./PopupPages/CloseButton";

import Home from "../../../../components/Home.js";
import ScamAlerts from "../../pages/Legal/ScamAlerts/index.js";
import "./style.scss";

class HomeView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialWindowHeight: window.innerHeight,
      verticalHeight: window.innerHeight,
      /*currentPage: null,
            popupPageOpen: false,
            popupPageExists: false,
            popupPagePlaced: false,
            popupPageMinHeight: 0,
            popupPageOffsetY: 0,
            pageParams: {},
            homeOffsetY: 0,
            homeContentExists: true,
            careers_roleId: null */
      currentRoute: null,
      currentPage: null,
      homeOffsetY: 0,
      homeContentExists: true,
      // backButton_isVertical: true,
      backButton_isActive: false,
      titleColorMode: "dark",
      tabActive: false,
      closeButtonType: "exit",
    };

    this.vars = {
      // prevHomeScroll: 0,
      // homeOffsetY: 0,
      resizeRequestTimer: null,
      windowSize: {
        width: window.innerWidth,
        height: window.innerHeight,
        aspect: window.innerHeight / window.innerWidth,
        devicePixelRatio: window.devicePixelRatio,
      },
      currentYear: new Date().getFullYear(),
      isScrolling: false,
      isSmoothScrolling: false,
      scrollSession_velocity: 0,
      scrollSession_maxVelocity: 0,
      scrollSession_prevPos: null,
      scrollSession_prevTime: null,
      isTouching: false,
      onTouchEnd: null,
    };

    this.timers = {
      isScrolling: false,
    };

    this.elements = {
      HomeView: null,
    };
  }

  componentDidMount() {
    // this.timerID = setInterval(() => this.tick(), 1000);

    this.props.history.scrollRestoration = "manual";
    if (typeof window !== `undefined`) {
      window.history.scrollRestoration = "manual";

      window.addEventListener("keydown", this.onKeyDown);
      window.addEventListener("resize", this.onResize);
      window.addEventListener("popstate", this.onPopstate);
      document.body.addEventListener("touchstart", this.onTouchStart);
      document.body.addEventListener("touchend", this.onTouchEnd);
      window.addEventListener("scroll", this.onScroll);
    }

    this.init();
  }

  componentWillUnmount() {
    // clearInterval(this.timerID);

    if (typeof window !== `undefined`) {
      // window.history.scrollRestoration = "auto";
      // window.history.scrollRestoration = "manual";

      window.removeEventListener("keydown", this.onKeyDown);
      window.removeEventListener("resize", this.onResize);
      window.removeEventListener("popstate", this.onPopstate);
      document.body.removeEventListener("touchstart", this.onTouchStart);
      document.body.removeEventListener("touchend", this.onTouchEnd);
      window.removeEventListener("scroll", this.onScroll);
    }
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // console.log("props.location.pathname --> CHANGED");
      Z.pageChanged();
    }
  }

  init = () => {
    const Z = this;

    // Z.setState({ initialWindowHeight: window.innerHeight }, () => {
    // ...

    Z.doResize();

    Z.pageChanged();
    // });
  };

  onKeyDown = (e) => {
    if (e.keyCode == 9) {
      this.setState({ tabActive: true });
    }
  };

  onResize = () => {
    const Z = this;

    // delayed resize
    /* if (Z.vars.resizeRequestTimer) clearTimeout(Z.vars.resizeRequestTimer);
        Z.vars.resizeRequestTimer = setTimeout(Z.doResize, 200); */
    Z.doResize();
  };

  doResize = () => {
    const Z = this;

    // Attempt #1 at preventing resize event when it's just iOS scrolling and removing the Safari toolbars:
    if (
      (!Z.vars.isScrolling && !Z.timers.isScrolling) ||
      Z.vars.windowSize != window.innerWidth
    ) {
      if (!Z.vars.isTouching) {
        if (typeof window !== `undefined`) {
          Z.vars.windowSize.width = window.innerWidth;
          Z.vars.windowSize.height = window.innerHeight;
          Z.vars.windowSize.aspect = window.innerHeight / window.innerWidth;
          Z.vars.windowSize.devicePixelRatio = window.devicePixelRatio;
        }

        const newState = {
          verticalHeight: Z.vars.windowSize.height,
        };

        /* if (Z.state.initialWindowHeight == null && Z.vars.windowSize.width <= 749) {
          newState.initialWindowHeight = Z.vars.windowSize.height;
      } */

        Z.setState(newState);
      }
    }
  };

  onTouchStart = (event) => {
    const Z = this;

    Z.vars.isTouching = true;
    // alert("Touching!");
  };

  onTouchEnd = (event) => {
    const Z = this;

    // Z.vars.isTouching = false;

    if (Z.vars.onTouchEnd != null) {
      Z.vars.onTouchEnd();
      Z.vars.onTouchEnd = null;
      Z.vars.isTouching = false;
    }
  };

  onScroll = (event) => {
    const Z = this;

    if (Z.state.currentPage == null) {
      // if on homepage
      // Z.vars.prevHomeScroll = Z.getScroll(); // for scroll position resetting on page change

      const nowDate = new Date();
      const nowMs = nowDate.getTime();

      Z.vars.isScrolling = true;

      clearTimeout(Z.timers.isScrolling);
      Z.timers.isScrolling = setTimeout(function () {
        if (Z.timers.isScrolling != null) {
          Z.scrollEnded({});
        }
      }, 128);
    }
  };

  scrollEnded = (endedParams) => {
    const Z = this;

    endedParams = endedParams || {
      touch: false,
    };

    clearTimeout(Z.timers.isScrolling);
    Z.timers.isScrolling = null;
    Z.vars.isScrolling = false;
  };

  getScroll = () => {
    return document.documentElement.scrollTop || document.body.scrollTop;
  };

  routeMatch = ({ route, path }) => {
    const Z = this;

    path = path || Z.props.location.pathname;

    const match = matchPath(path, {
      path: route,
      exact: false,
      strict: false,
    });

    var returnObj = {};
    if (match != null) {
      const isMatch = match.path == route;

      returnObj = {
        isMatch: isMatch,
        isExact: match.isExact,
        params: match.params,
        path: match.path,
        url: match.url,
      };
    } else {
      returnObj = {
        isMatch: false,
        isExact: null,
        params: null,
        path: null,
        url: null,
      };
    }

    return returnObj;
  };

  onPopstate = (event) => {
    // Listens for browser back button, etc.
    // Our "Link" element also triggers a "popstate" event on click.
    const Z = this;

    let currentScrollPosition =
      document.documentElement.scrollTop || document.body.scrollTop;
    window.appCurrentScrollPosition = currentScrollPosition;

    Z.pageChanged();
  };

  pageChanged = (newPath) => {
    const Z = this;

    newPath = newPath || window.location.pathname;

    var currentPage = null,
      roleId = null,
      match = null;

    match = Z.routeMatch({ route: ROUTES.CAREERS_ROLE, path: newPath });
    if (match.isMatch) {
      // console.log("ROUTE: Careers / Role");
      currentPage = match.path;
      roleId = match.params.roleId;
    } else {
      match = Z.routeMatch({ route: ROUTES.CAREERS_THANK_YOU, path: newPath });
      if (match.isMatch) {
        currentPage = match.path;
      } else {
        match = Z.routeMatch({
          route: ROUTES.CAREERS_SUBMISSION_ERROR,
          path: newPath,
        });
        if (match.isMatch) {
          currentPage = match.path;
        } else {
          match = Z.routeMatch({ route: ROUTES.HOME_CAREERS, path: newPath });
          if (match.isMatch) {
            // console.log("ROUTE: Careers / (index)");
            currentPage = match.path;
          } else {
            match = Z.routeMatch({ route: ROUTES.HOME_TOS, path: newPath });
            if (match.isMatch) {
              // console.log("ROUTE: TOS");
              currentPage = match.path;
            } else {
              match = Z.routeMatch({
                route: ROUTES.HOME_COOKIES,
                path: newPath,
              });
              if (match.isMatch) {
                // console.log("ROUTE: Cookies");
                currentPage = match.path;
              } else {
                match = Z.routeMatch({
                  route: ROUTES.HOME_PRIVACY_POLICY,
                  path: newPath,
                });
                if (match.isMatch) {
                  // console.log("ROUTE: Privacy policy");
                  currentPage = match.path;
                } else {
                  match = Z.routeMatch({
                    route: ROUTES.CCPA,
                    path: newPath,
                  });
                  if (match.isMatch) {
                    currentPage = match.path;
                  } else {
                    match = Z.routeMatch({
                      route: ROUTES.SCAM_ALERTS,
                      path: newPath,
                    });
                    if (match.isMatch) {
                      currentPage = match.path;
                    } else {
                      match = Z.routeMatch({
                        route: ROUTES.INDEX,
                        path: newPath,
                      });
                      if (match.isMatch) {
                        currentPage = null;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    Z.setState({
      currentRoute: match,
      currentPage: currentPage,
    });

    // ...
  };

  updateBackButton = ({ isActive }) => {
    const Z = this;

    // isVertical = isVertical != null ? isVertical : true;
    isActive = isActive != null ? isActive : false;

    Z.setState({
      // backButton_isVertical: isVertical,
      backButton_isActive: isActive,
    });
  };

  setCloseButtonType = (type) => {
    const Z = this;
    Z.setState({ closeButtonType: type });
  };

  setTitleColor = (mode) => {
    const Z = this;

    var titleMode = "light";
    if (mode == "dark") {
      titleMode = "dark";
    }

    Z.setState({ titleColorMode: titleMode });
  };

  snapToHomeSection = (scrollSession) => {
    const Z = this;
    scrollSession = scrollSession || {};

    if (!Z.vars.isSmoothScrolling) {
      const currentScrollPos = Z.getScroll();

      // const endOffset = (scrollSession.projectedEndPos || currentScrollPos) - currentScrollPos;

      // Get home section positions
      var secPositions = [];
      const secElements = Z.elements.homeContent.querySelectorAll(
        ".home-section",
      );
      const secElements_disabled = Z.elements.homeContent.querySelectorAll(
        ".home-section.disable-smooth-scroll",
      );

      var closestSecTop = null;
      var closestSecIndex = null;
      var disableAreas = [];

      secElements_disabled.forEach((el) => {
        const elBounds = el.getBoundingClientRect();
        const scrollOffset = elBounds.top; // NOTE: .top is element's top relative to window, not document
        const elHeight = elBounds.height;
        // var fromPos = elBounds.top; // + elBounds.height / 4;
        var fromPos = el.offsetTop - window.innerHeight;
        // var fromPos = elBounds.top;
        var toPos = el.offsetTop + el.offsetHeight / 2;
        if (el.classList.contains("smooth-scroll-end-of-page")) {
          // toPos = 99999999;
        }
        var thisDisabledArea = {
          from: fromPos - currentScrollPos,
          to: toPos - currentScrollPos,
        };
        disableAreas.push(thisDisabledArea);
      });

      console.log("SNAP - disableAreas:", disableAreas);
      console.log("SNAP - currentScrollPos:", currentScrollPos);

      var isDisabledArea = false;
      disableAreas.forEach((dArea) => {
        // if (currentScrollPos > dArea.from && currentScrollPos < dArea.to) {
        if (dArea.from - 0 < 0 && dArea.to > 0) {
          isDisabledArea = true;
        }
      });

      if (!isDisabledArea) {
        secElements.forEach((el) => {
          const elBounds = el.getBoundingClientRect();
          secPositions.push({
            // element: el,
            bounds: elBounds,
          });
          const scrollOffset = elBounds.top; // NOTE: .top is element's top relative to window, not document
          if (Math.abs(scrollOffset) < Math.abs(closestSecTop ?? 99999999)) {
            closestSecTop = scrollOffset;
            closestSecIndex = secPositions.length - 1;
          }
        });

        if (Z.getScroll() > 0) {
          // alert(`end offset == ${endOffset}`);
          // Z.smoothScrollTo(closestSecTop + Z.getScroll() + endOffset, 320);
          // Was part of snap scroll, but snap scroll is disabled:
          // Z.smoothScrollTo(closestSecTop + Z.getScroll(), 320);
        }
      }
    }

    console.log("secPositions:", secPositions);
  };

  smoothScrollTo = (scrollToPos, duration) => {
    const Z = this;

    var currentSmoothScrollPos = Z.getScroll();

    function scrollToX(yFrom, yTo, t01, speed, step, motion) {
      if (Z.vars.isScrolling) {
        Z.vars.isSmoothScrolling = false;
      } else if (Z.vars.isSmoothScrolling) {
        // Check if user has scrolled manually, and cancel if so:
        if (
          Z.getScroll() <= currentSmoothScrollPos + 1 &&
          Z.getScroll() >= currentSmoothScrollPos - 1
        ) {
          if (t01 < 0 || t01 > 1 || speed <= 0) {
            // element.scrollTop = xTo;
            window.scrollTo(0, yTo);
            Z.vars.isSmoothScrolling = false;
            return;
          }
          const smoothScrollToPos = yFrom - (yFrom - yTo) * motion(t01);
          currentSmoothScrollPos = smoothScrollToPos;
          window.scrollTo(0, smoothScrollToPos);
          t01 += speed * step;

          setTimeout(function () {
            scrollToX(yFrom, yTo, t01, speed, step, motion, smoothScrollToPos);
          }, step);
        } else {
          Z.vars.isSmoothScrolling = false;
        }
      }
    }
    function easeOutCuaic(t) {
      t--;
      return t * t * t + 1;
    }

    console.log("check smooth scroll...");
    if (!Z.vars.isSmoothScrolling) {
      console.log("DO SMOOTH SCROLL:");
      Z.vars.isSmoothScrolling = true;
      scrollToX(Z.getScroll(), scrollToPos, 0, 1 / duration, 20, easeOutCuaic);
    } else {
      console.log("Already smooth scrolling!");
    }
  };

  render() {
    var Z = this;

    var sectionHeight = Z.state.verticalHeight;

    return (
      <div
        className={`HomeView ${Z.state.tabActive ? "tab-active" : ""}`}
        ref={(el) => (Z.elements.HomeView = el)}
      >
        <CloseButton
          isActive={Z.state.backButton_isActive}
          type={Z.state.closeButtonType}
        />
        <PopupPages
          home={Z}
          currentRoute={Z.state.currentRoute}
          updateBackButton={Z.updateBackButton}
          closeButtonType={Z.state.closeButtonType}
          setCloseButtonType={Z.setCloseButtonType}
          isRoot={{
            [ROUTES.HOME_CAREERS]: true,
            [ROUTES.CAREERS_ROLE]: false,
            [ROUTES.CAREERS_THANK_YOU]: true,
            [ROUTES.CAREERS_SUBMISSION_ERROR]: false,
            [ROUTES.HOME_TOS]: true,
            [ROUTES.HOME_PRIVACY_POLICY]: true,
            [ROUTES.HOME_COOKIES]: true,
            [ROUTES.CCPA]: true,
          }}
          pages={[
            {
              routes: [
                ROUTES.HOME_CAREERS,
                ROUTES.CAREERS_ROLE,
                ROUTES.CAREERS_THANK_YOU,
                ROUTES.CAREERS_SUBMISSION_ERROR,
              ],
              content: <CareersPage currentRoute={Z.state.currentRoute} />,
            },
            {
              routes: [ROUTES.HOME_TOS],
              content: <TermsOfService currentRoute={Z.state.currentRoute} />,
            },
            {
              routes: [ROUTES.HOME_PRIVACY_POLICY],
              content: <PrivacyPolicy currentRoute={Z.state.currentRoute} />,
            },
            {
              routes: [ROUTES.HOME_COOKIES],
              content: <CookiesPolicy currentRoute={Z.state.currentRoute} />,
            },
            {
              routes: [ROUTES.CCPA],
              content: <CCPA currentRoute={Z.state.currentRoute} />,
            },
            {
              routes: [ROUTES.SCAM_ALERTS],
              content: <ScamAlerts currentRoute={Z.state.currentRoute} />,
            },
          ]}
        />
        <div
          className="HomeView-inner"
          style={{
            display: Z.state.homeContentExists ? "flex" : "none",
            marginTop: `${Z.state.homeOffsetY}px`,
          }}
        >
          <SEO
            title="Welcome Home"
            description="Bespoke advertising agency dedicated to Apple."
          />
          <div
            className="home-content"
            ref={(el) => (Z.elements.homeContent = el)}
          >
            <Home />
          </div>
        </div>
      </div>
    );
  }
}

HomeView.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
};

export default withRouter(HomeView);
